// extracted by mini-css-extract-plugin
export var section = "style-module--section--usIgF";
export var heading = "style-module--heading--AGrQr";
export var legalContainer = "style-module--legalContainer--ixI0D";